import { Translation } from 'cng-common/features/translations'
import { IColumn } from 'core-components/library/list/types'
import { Tooltip } from 'core-components/library/tooltip'

import { BUSINESS_PRIORITIES_TRANSLATION_KEYS } from '../../../configs/translations'
import { IBusinessPriority } from '../../../model/types'
import { BusinessPriorityMarket } from '../../businessPriorityMarket/BusinessPriorityMarket'
import { BusinessPriorityProgramOffering } from '../../businessPriorityProgramOffering/BusinessPriorityProgramOffering'
import { BusinessPriorityStatus } from '../../businessPriorityStatus/BusinessPriorityStatus'
import styles from '../BusinessPrioritiesTable.module.scss'

const KEYS = BUSINESS_PRIORITIES_TRANSLATION_KEYS

interface IGetColumnsParams {
  isWorldwide: boolean
  market?: string
}

export const getColumns = ({
  isWorldwide,
  market,
}: IGetColumnsParams): IColumn<IBusinessPriority>[] => {
  const isMarketScope = !isWorldwide && Boolean(market)

  const columns: IColumn<IBusinessPriority>[] = [
    {
      field: 'name',
      title: KEYS.table.columnName,
      disableSort: true,
      hideSettings: true,
      titleRender: () => <Translation text={KEYS.table.columnName} />,
      renderFunction: (item) => (
        <div className={styles.nameCell}>
          <div className={styles.name}>{item.name}</div>
          <Tooltip tipContent={() => <>{item.description}</>}>
            <div className={styles.description}>{item.description}</div>
          </Tooltip>
        </div>
      ),
    },
    {
      field: 'markets',
      title: KEYS.table.columnMarkets,
      disableSort: true,
      hideSettings: true,
      titleRender: () => <Translation text={KEYS.table.columnMarkets} />,
      renderFunction: (item) => {
        return (
          <div className={styles.pills}>
            {item.markets.map((market) => (
              <BusinessPriorityMarket key={market} market={market} />
            ))}
          </div>
        )
      },
    },
    {
      field: 'programOfferings',
      title: KEYS.table.columnProgramOfferings,
      disableSort: true,
      hideSettings: true,
      titleRender: () => <Translation text={KEYS.table.columnProgramOfferings} />,
      renderFunction: (item) => {
        return (
          <div className={styles.pills}>
            {item.programOfferings.map((offering) => (
              <BusinessPriorityProgramOffering key={offering} programOffering={offering} />
            ))}
          </div>
        )
      },
    },
    {
      field: 'status',
      title: isMarketScope ? KEYS.table.columnStatusInMarket : KEYS.table.columnStatus,
      disableSort: true,
      hideSettings: true,
      titleRender: () =>
        isMarketScope ? (
          <Translation
            text={KEYS.table.columnStatusInMarket}
            replaceParams={[
              {
                value: market!,
                key: '{market}',
              },
            ]}
          />
        ) : (
          <Translation text={KEYS.table.columnStatus} />
        ),
      renderFunction: (item) => {
        return <BusinessPriorityStatus status={item.status} />
      },
    },
    {
      field: 'kiCount',
      title: KEYS.table.columnKeyInitiatives,
      disableSort: true,
      hideSettings: true,
      titleRender: () => <Translation text={KEYS.table.columnKeyInitiatives} />,
      renderFunction: (item) => <>{item.kiCount}</>,
    },
  ]

  if (isWorldwide) {
    columns.push({
      field: 'marketOverrides',
      title: KEYS.table.columnMarketOverrides,
      disableSort: true,
      hideSettings: true,
      titleRender: () => <Translation text={KEYS.table.columnMarketOverrides} />,
      renderFunction: () => <>-</>,
    })
  }

  return columns
}
